<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  created() {
    const token = sessionStorage.getItem('jwtToken');
    if (token) {
      this.$root.isLogin = true
    }
  },
  data() {
    return {}
  },
  computed: {
    currentComponent: function () {
      var isLogin = this.$root.isLogin
      if (isLogin) {
        return "user";
      }
      return "login";
    },
  },
  methods:{

  }
}
</script>

<style lang="scss">
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  list-style: none;
}
.el-header,.el-main{
  padding:0!important;
}
</style>
